import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=3c4822c6&"
import script from "./CompanyEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&id=3c4822c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports